import Styles from './ListenNow.module.scss';
import classnames from "classnames"

import { ReactComponent as AppleIcon } from "../../../icons/common/apple_logo.svg"
import Poster from "../../../icons/common/listen_now_poster.webp"

const ListenNow = () => {

    const openLink = () => {
        window.open("https://music.apple.com/")
    }

    return (
        <div className={Styles.container}>
            <div className={Styles.flex}>
                <div className={Styles.info}>
                    <div className={Styles.branding}>
                        <div className={Styles.icon}>
                            <AppleIcon />
                        </div>
                        <div className={Styles.label}>
                            Apple
                        </div>
                    </div>
                    <div className={Styles.header}>
                        Discover new music every day.
                    </div>
                    <div className={Styles.text}>
                        Get playlists and albums inspired by the artists and generes you are listening to. 1 month free then $10.99/month.
                    </div>
                    
                    <div className={Styles.buttons}>
                    <div className={Styles.visit_link} onClick={openLink}>
                        Try it free
                    </div>
                    <a href="https://www.apple.com/apple-music/" target='_blank' className={Styles.direct_link}>Learn more</a>
                    </div>
                </div>
            </div>
            <div className={classnames(Styles.flex, Styles.full)}>
                <img className={Styles.poster} src={Poster} />
            </div>
        </div>
    )
}

export default ListenNow
